<template>
  <label
    :data-test-id="dataTestId ?? generatedUUID"
    class="flex items-center cursor-pointer gap-2 md:gap-4"
  >
    <Checkbox v-model="model" :disabled="disabled" binary />

    <span class="select-none text-black" :class="spanClass">
      <slot />
    </span>
  </label>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    rootClass?: string
    disabled?: boolean
    dataTestId?: string
    spanClass?: string
  }>(),
  {
    rootClass: '',
    disabled: false,
    dataTestId: undefined,
    spanClass: undefined,
  }
)

const { generateUUID } = componentUUID(props.dataTestId)
const generatedUUID = generateUUID()

const emit = defineEmits(['change'])

const model = defineModel({ type: Boolean })

watch(model, (value) => emit('change', value))
</script>

<style scoped></style>
